/**
 * Centralized configuration for all backend services
 *
 * This file manages environment variables for:
 * - Supabase (authentication and database)
 * - AI Engine (FastAPI backend)
 * - Application settings
 */

export const config = {
  app: {
    name: import.meta.env.VITE_APP_NAME || 'CredexAI',
  },
  supabase: {
    url: import.meta.env.VITE_SUPABASE_URL || '',
    anonKey: import.meta.env.VITE_SUPABASE_ANON_KEY || '',
  },
  ai: {
    apiUrl: import.meta.env.VITE_AI_API_URL || 'http://localhost:8000',
    // HIGH FIX GAP 4: Frontend flag awareness for streaming
    // Defaults to true to match backend default behavior
    streamingEnabled: import.meta.env.VITE_STREAMING_ENABLED !== 'false',
  },
} as const;

// Validation helper to ensure required config is present
export const validateConfig = () => {
  const errors: string[] = [];

  if (!config.supabase.url) {
    errors.push('VITE_SUPABASE_URL is not defined');
  }
  if (!config.supabase.anonKey) {
    errors.push('VITE_SUPABASE_ANON_KEY is not defined');
  }

  if (errors.length > 0) {
    console.warn('Configuration warnings:', errors);
  }

  return errors.length === 0;
};

